export default __webpack_public_path__ + "static/media/FilePresentOutlined.31d997d3.svg";